'use client'

import { getCommonPosthogSettings } from '@tucan/utils'
import { flushPendingExceptions } from '@tucan/utils/error-tracking'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren, useEffect } from 'react'

const { posthogConfig, posthogKey } = getCommonPosthogSettings()

export function PhProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    posthog.init(posthogKey, {
      ...posthogConfig,
      // error tracking: report unhandled errors and rejections automatically,
      // handled errors are reported explicitly via `captureException`
      capture_exceptions: {
        capture_console_errors: false,
        capture_unhandled_errors: true,
        capture_unhandled_rejections: true,
      },
    })

    // errors captured during the first render happened before init
    flushPendingExceptions()
  }, [])

  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  )
}
